import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Icon } from "common/components";
import { userActions } from "common/redux/user";
import { WindowUtil } from "common";
import { UserLoginStatus } from "common/enums/api-status.enum";
import { ReactComponent as Logo } from "assets/media/icons/custom/signedOutIcon.svg";

import "./SignedOutView.scss";
import { SvgIcon } from "@mui/material";

const SignedOutView: FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    document.body.style.paddingTop = "0px";
    WindowUtil.addEventListener("popstate", handleLogin);
    return () => {
      WindowUtil.removeEventListener("popstate", handleLogin);
    };
  }, []);

  const handleLogin = () => {
    dispatch(userActions.setUserSigningStatus(UserLoginStatus.LOGIN_PROGRESS));
    WindowUtil.locationReload();
  };

  return (
    <div className="signed-out">
      <Icon className="signed-out-icon" src={<Logo />} isCustom={true} />
      <h1>Your have been logged out successfully!</h1>
      <div className="signed-out__button">
        <Button variant={"primary"} type={"button"} onClick={handleLogin}>
          Sign in
        </Button>
      </div>
    </div>
  );
};

export default SignedOutView;
